import { QueryClient } from '@tanstack/react-query';
import { shouldRetryRequest } from '@opengoal/http';

/**
 * The app's server-state cache.
 *
 * TanStack Query owns everything that comes from the API. Zustand owns local UI
 * preferences (theme, sidebar) and nothing else — the moment server data is
 * copied into a zustand store it starts going stale, and reconciling the two is
 * a class of bug this split avoids entirely.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Admin data is read far more often than it changes. 30s of staleness
      // removes most redundant refetches while keeping lists feeling live.
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      retry: shouldRetryRequest,
      // Refetching on every window focus is noisy in a tool people leave open
      // all day next to their email.
      refetchOnWindowFocus: false,
      refetchOnReconnect: true,
    },
    mutations: {
      // A failed write must never be retried automatically — at this layer we
      // cannot tell a create from a retry, and duplicating a deal or an
      // invitation is worse than showing an error.
      retry: false,
    },
  },
});
